"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disclosure = exports.icon = exports.content = exports.container = exports.wrapper = void 0;

var _util = require("../../../util");

const wrapper = ({
  cssProps
}) => ({
  nested: {
    '&.alertWrapper': {
      borderRadius: cssProps.variant !== 'transparent' ? 8 : 0
    }
  }
});

exports.wrapper = wrapper;

const container = ({
  theme
}) => ({
  width: '100%',
  padding: (0, _util.spacing)(theme, ['large', 'xlarge'])
});

exports.container = container;

const content = () => ({
  flexGrow: 1
});

exports.content = content;

const icon = ({
  theme
}) => ({
  margin: (0, _util.spacing)(theme, [0, 'xsmall', 0, 0])
});

exports.icon = icon;

const disclosure = () => ({
  flexShrink: 0
});

exports.disclosure = disclosure;
//# sourceMappingURL=Alert.style.js.map